// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rUoBF","type":"styles_type__2sm1o","choices":"styles_choices__3ZfK8"};